'use client'

import { useState } from 'react'
import { Space } from '@cocoonspace/sdk-js/types/space'
import { buttonVariants } from '@cocoonspace/ui/components/button'
import {
	Dialog,
	DialogContent,
	DialogTrigger,
} from '@cocoonspace/ui/components/dialog'
import { useLingui } from '@lingui/react/macro'
import { TwicImg } from '@twicpics/components/react'
import { ImageIcon } from 'lucide-react'

import { VenueImageCarousel } from './venue-image-carousel'

const SeePhotosFakeButton = () => {
	const { t } = useLingui()

	return (
		<div
			className={buttonVariants({
				className:
					'!text-foreground hover:!text-white absolute bottom-4 left-4 gap-2 bg-white/60',
				size: 'sm',
			})}
		>
			<ImageIcon />
			{t`Voir les photos`}
		</div>
	)
}

export const VenuePhotos = ({ photos }: { photos: Space['images'] }) => {
	const [defaultIndex, setDefaultIndex] = useState(0)

	if (!photos?.length) return null

	return (
		<>
			<div className='overflow-hidden lg:hidden'>
				<VenueImageCarousel
					defaultIndex={defaultIndex}
					photos={photos}
				/>
			</div>

			<div className='hidden flex-col gap-y-2 lg:flex'>
				<Dialog>
					<DialogTrigger asChild>
						<button
							className='relative hidden overflow-hidden rounded-lg bg-slate-200 lg:block'
							onClick={() => setDefaultIndex(0)}
							type='button'
						>
							<TwicImg
								alt={photos?.[0].title}
								focus='50px100p'
								mode='cover'
								preTransform='quality=80'
								ratio='368/235'
								src={photos?.[0].path}
								step={1}
							/>

							<SeePhotosFakeButton />
						</button>
					</DialogTrigger>

					<div className='grid grid-cols-4 gap-x-2'>
						{photos?.slice(1, 4).map((image, i) => (
							<DialogTrigger
								asChild
								key={image.id}
							>
								<div
									className='flex-1 cursor-pointer overflow-hidden rounded-lg bg-slate-200'
									onClick={() => setDefaultIndex(i + 1)}
								>
									<TwicImg
										alt={image.title}
										focus='50px100p'
										ratio='86/56'
										src={image.path}
									/>
								</div>
							</DialogTrigger>
						))}
					</div>

					<DialogContent className='h-screen w-screen !max-w-full !rounded-none'>
						<VenueImageCarousel
							defaultIndex={defaultIndex}
							photos={photos}
						/>
					</DialogContent>
				</Dialog>
			</div>
		</>
	)
}

VenuePhotos.displayName = 'SpaceDetailsPhotos'
